export type ComparisonCategoryPriority = {
  primaryCount: number
  efficiencyPoints: number
  recommendationScore: number
}

// Keep the priority fields in category-report-queries.ts in this same order.
export function compareCategoryPriority(
  left: ComparisonCategoryPriority,
  right: ComparisonCategoryPriority,
): number {
  return (
    right.primaryCount - left.primaryCount ||
    right.efficiencyPoints - left.efficiencyPoints ||
    right.recommendationScore - left.recommendationScore
  )
}
